import { usePostMutation } from "@/api/swr/useMutation";
import { z } from "zod";

type Config = Parameters<typeof usePostMutation<z.ZodUndefined, z.ZodNull>>[3];

export const useConfirmReAssessment = (id: number, config?: Config) => {
  return usePostMutation(
    z.undefined(),
    z.null(),
    `/console/re_assessments/${id}/confirm`,
    config,
  );
};
